<!-- =========================================================================================
  File Name: ECommerceItemDetail.vue
  Description: eCommerce Item Detail page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div >
  <div class="vx-row">
            

            
            <div class="vx-col w-full sm:w-1/2 lg:w-2/3 mb-base mx-auto">
                <vx-card>
                    <div class="  ">
                        <!--div class="mb-4">Formateur:</div-->
                        <div class="flex" ><p class="text-xl">{{data_local.nom_domaine}}</p>
                    </div></div>
                    <vs-divider></vs-divider>
                    <div class="flex justify-between flex-wrap pl-20 pr-20">
                        <span>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12"><p class="text-xl">{{data_local.nb_formation}} </p></vs-col>
                            <p class="text-grey">formations</p>
                        </span>
                        
                        <span>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12"><p class="text-xl">{{data_local.nb_participation}} </p></vs-col>
                            <p class="text-grey">Participons</p>
                        </span>
                        <span>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12"><p class="text-xl">{{data_local.nb_formateur}} </p></vs-col>
                            <p class="text-grey">formateurs</p>
                        </span>
                    </div>
                    <vs-divider></vs-divider>
                    <div class="vx-row">
                        <div class="vx-col w-1/2 mb-3">
                            <small>formation: {{(data_local.nb_formation/data_local.nb_formation_total*100).toFixed(2)}}%</small>
                            <vs-progress :percent="Number(data_local.nb_formation/data_local.nb_formation_total*100)" :color="getPopularityColor(Number((data_local.nb_formation/data_local.nb_formation_total*100)))" class="block mt-1" />
                        </div>
                        <div class="vx-col w-1/2 mb-3">
                            <small>Participons: {{(data_local.nb_participation/data_local.nb_participation_total*100).toFixed(2)}}%</small>
                            <vs-progress :percent="Number(data_local.nb_participation/data_local.nb_participation_total*100)" :color="getPopularityColor(Number((data_local.nb_participation/data_local.nb_participation_total*100)))" class="block mt-1" />
                        </div>
                        <div class="vx-col w-1/2 mb-3">
                            <small>formateur: {{(data_local.nb_formateur/data_local.nb_formateur_total*100).toFixed(2)}}%</small>
                            <vs-progress :percent="Number(data_local.nb_formateur/data_local.nb_formateur_total*100)" :color="getPopularityColor(Number((data_local.nb_formateur/data_local.nb_formateur_total*100)))" class="block mt-1" />
                        </div>
                    </div>
                    <vs-divider></vs-divider>

                </vx-card>
            </div>

            
        </div>

                
  </div>
</template>

<script>
import vSelect from 'vue-select'
import moduledomaine from '@/store/domaine/moduledomaine.js'

//import axios from "../../../../http/axios/index.js"
//import users from "../../../../fake-db/data/user-management/index.js"
export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formations_length:0,
      formateurs_length:0,
      i:0,
      data_local: JSON.parse(JSON.stringify(this.data[0])),
     
    }
  },
  computed: {
  
    validateForm() {
      return !this.errors.any()
    }
  },
  created() {
    // Register Module UserManagement Module
    if(!moduledomaine.isRegistered) {
      this.$store.registerModule('domaine', moduledomaine)
      moduledomaine.isRegistered = true
    }
    this.$store.dispatch("domaine/fetchFormations",this.$route.params.userId).catch(err => { console.error(err) })
    },
  methods: {
    getPopularityColor(num) {
      if(num > 67) return "success"
      if(num >66) return "primary"
      if(num >= 50) return "warning"
      if(num < 50) return "danger"
      return "primary"
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
   confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm Delete`,
        text: `You are about to delete "${this.data_local.nom}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      })
      
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      //this.$router.push({name:'app-user-list'});
      //this.showDeleteSuccess()
       
      /* UnComment below lines for enabling true flow if deleting user */
       this.$store.dispatch("formation/removeRecord", this.data_local.id)
         .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
         .catch(err => { console.error(err)       })
         
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    } 
    
  },
}
</script>
<style lang="scss">

@import "@/assets/scss/vuexy/_variables.scss";

#item-detail-page {
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .item-features {
    background-color: #f7f7f7;

    .theme-dark & {
      background-color: $theme-dark-secondary-bg;
    }
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
      // padding-right: 2rem;
      // padding-left: 2rem;

    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0,0,0,0.1), 0 5px 12px 0 rgba(0,0,0,0.08) !important;

        .theme-dark & {
          background-color: $theme-light-dark-bg;
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0
    }

    .swiper-button-prev {
      left: 0;
    }
  }
}
</style>
